import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const mqttSubscribeUiNodeSpec: UiNodeSpec<'mqttSubscribe'> = {
    requiredSockets: [ 'topic' ],
    cfg: () => ({
        disabled: false,
        controlValues: {
            autoSubscribe: true,
            qos: 0,
            topic: '',
        },
        id: getUID(),
        kind: 'mqttSubscribe',
    }),
    controls: getNodeCfg => ({
        autoSubscribe: { cfg: { kind: 'boolean', label: 'Auto Subscribe' }, nodeCfg: getNodeCfg(), value: getNodeCfg().controlValues.autoSubscribe },
        qos: {
            cfg: {
                items: [
                    { label: '0', value: 0 },
                    { label: '1', value: 1 },
                    { label: '2', value: 2 },
                ],
                kind: 'selection',
                label: 'QoS',
            },
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.qos,
        },
    }),
    inputs: nodeCfg => ({
        topic: {
            control: {
                cfg: { kind: 'text', nullable: true },
                nodeCfg,
                nullable: true,
                value: nodeCfg.socketDefaults?.inputs?.topic || '',
            },
            socket: 'string',
            label: 'Topic',
        },
        resubscribe: { socket: 'event', label: 'Resubscribe' },
    }),
    kindLabel: 'MQTT Subscribe',
    nodeCategory: 'external',
    outputs: () => ({
        event: { socket: 'event', label: 'On Message' },
        payload: { socket: 'string', label: 'Payload' },
    }),
    validator: () => true,
};
